import React from 'react'
import UpcomingTrips from '../components/UpcomingTrips'
import DestinationsWeCover from '../components/DestinationsWeCover'
import CustomPackage from '../components/CustomPackage'
import MonthlyOffers from "../components/MonthlyOffers";
const HolidayPackages = () => {
  return (
    <div>
      <MonthlyOffers />
      <UpcomingTrips/>
      <DestinationsWeCover/>
      <CustomPackage/>
    </div>
  )
}

export default HolidayPackages
